export const getRequiredAspectRatio = () => {
  return 16 / 9;
};
